/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */




$('a.sizeItem').click(function() {
  //   alert ($(this).attr('value'));
  var ele = $(this);
 // $(ele).attr("data-action","open-drawer").attr("data-drawer-id","sidebar-cart").attr("aria-label","Open cart");
  var id = $(this).attr('value');
  //$(this).parents('form').find("[name='id']").val();
  debugger;
  //$(this).closest('form').submit();
  $(this).parents('form').find("[name='id'] option[value='"+ id +"']").prop('selected', true)
  //var form_id = $(this).closest('form').attr('id');
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: $(this).parents('form').serialize(),
    success: function() {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true  //this code is for prestige theme, is to refresh the cart
      }));
      $(ele).parents('.caption').find('.pro_size').hide();
      $(ele).parents('.caption').find('button.quick_add').show();
    }
   // success: function(){
   //   alert("suc");
   //   $.ajax({
   //     url:'/cart?view=drawer&timestamp='+Date.now(),
   //     type:'GET',
  //      success: function(data) {
  //        debugger;
  //        $('#sidebar-cart').find('.Cart__ItemList').html(data);
  //        alert("disp");



  //      }
  //    });
    //}
  });
  $('.cart_dr').trigger( "click" );
});
$('button.quick_add').click(function() {
  $(this).parent('.caption').find('.pro_size').show();
  $(this).hide();
});

(function () {
  // Function to initialize Splide sliders
  function initializeSplide(sliderSelector) {
    const sliders = document.querySelectorAll(sliderSelector);

    sliders.forEach((slider) => {
      // Check if the slider is already initialized
      if (!slider.classList.contains('splide-initialized')) {
        const splide = new Splide(slider, {
          autoWidth: true,
          pagination: false,
          arrows: false,
          speed: 800,
          loop: true,
        });

        // Adjust arrows and drag behavior based on overflow
        splide.on('overflow', function (isOverflow) {
          splide.options = {
            arrows: isOverflow,
            drag: isOverflow,
          };
        });

        // Mount the slider
        splide.mount();

        // Mark the slider as initialized
        slider.classList.add('splide-initialized');
      }
    });
  }

  // Initialize sliders on page load
  if (window.Splide) {
    initializeSplide('.customSlider');
  }

  // Reinitialize sliders when a new Shopify section is loaded
  document.addEventListener('shopify:section:load', (event) => {
    const newSection = event.target;
    const newSliders = newSection.querySelectorAll('.customSlider');
    if (newSliders.length) {
      initializeSplide('.customSlider');
    }
  });

  // Optional: Handle section reordering or reloading
  document.addEventListener('shopify:section:reorder', () => {
    initializeSplide('.customSlider');
  });
})();

